module.exports = __webpack_public_path__ + "static/media/juggernaut.486dbb28.png";